import StepDrawer from './StepDrawer';
import { helpers } from '../services/helpers';
import Selector from './Selector';

function ActivitySelectorDrawer({
    activityLevel,
    setActivityLevel,
    currentStep,
    totalSteps,
    onCancel,
    onContinue,
    onBack,
    isEdit
}) {

    return (
        <StepDrawer
            currentStep={currentStep}
            totalSteps={totalSteps}
            onCancel={onCancel}
            onContinue={onContinue}
            onBack={onBack}
            title={isEdit ? "Edit Pain Diary Entry" : "New Pain Diary Entry"}
        >
            <Selector
                score={activityLevel}
                setScore={setActivityLevel}
                getColorForScore={helpers.getColorForScore}
                getIconForScore={helpers.getActivityIconForScore}
                getDescriptionForScore={helpers.getDescriptionForScore}
                label="Activity Level"
            />
        </StepDrawer>
    );
}

export default ActivitySelectorDrawer;